import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext"; // Ajuste o caminho conforme necessário
import {
  doc,
  updateDoc,
  setDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../config/firebase"; // Ajuste o caminho conforme necessário

// Definição dos temas disponíveis
export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
  SPRING: "spring",
  EXECUTIVE: "executive",
  ELEGANT: "elegant",
  MODERN: "modern", // Novo tema
};

export const THEME_LABELS = {
  [THEMES.LIGHT]: "Claro",
  [THEMES.DARK]: "Escuro",
  [THEMES.SPRING]: "Verde Primavera",
  [THEMES.EXECUTIVE]: "Azul Executivo",
  [THEMES.ELEGANT]: "Rosa Elegante",
  [THEMES.MODERN]: "Moderno",
};

// Configurações de cada tema
export const THEME_CONFIGS = {
  [THEMES.LIGHT]: {
    name: "Claro",
    icon: "☀️",
    primary: "#2563eb", // Azul principal
    primaryHover: "#1d4ed8",
    primaryActive: "#1e40af",
    secondary: "#64748b", // Cinza secundário
    secondaryHover: "#475569",
    secondaryActive: "#334155",
    background: "#ffffff", // Fundo claro
    surface: "#f8fafc", // Superfície de componentes (cards, etc.)
    surfaceHover: "#f1f5f9",
    text: "#1e293b", // Texto principal escuro
    textSecondary: "#64748b", // Texto secundário/sutil
    textMuted: "#94a3b8", // Texto muito sutil, placeholders
    border: "#e2e8f0", // Bordas leves
    borderLight: "#f0f4f8",
    accent: "#3b82f6", // Cor de destaque (pode ser a mesma que primary)
    success: "#10b981", // Verde para sucesso
    successHover: "#047857",
    warning: "#f59e0b", // Amarelo para aviso
    warningHover: "#b45309",
    error: "#ef4444", // Vermelho para erro
    errorHover: "#b91c1c",
    info: "#06b6d4", // Azul ciano para informação
    infoHover: "#0891b2",
    shadow: "rgba(0, 0, 0, 0.05)", // Sombra leve
    shadowHover: "rgba(0, 0, 0, 0.1)",
  },
  [THEMES.DARK]: {
    name: "Escuro",
    icon: "🌙",
    primary: "#3b82f6", // Azul principal
    primaryHover: "#2563eb",
    primaryActive: "#1d4ed8",
    secondary: "#94a3b8", // Cinza secundário
    secondaryHover: "#64748b",
    secondaryActive: "#475569",
    background: "#0f172a", // Fundo escuro
    surface: "#1e293b", // Superfície de componentes
    surfaceHover: "#334155",
    text: "#f1f5f9", // Texto principal claro
    textSecondary: "#94a3b8", // Texto secundário/sutil
    textMuted: "#64748b", // Texto muito sutil, placeholders
    border: "#334155", // Bordas escuras
    borderLight: "#475569",
    accent: "#60a5fa", // Cor de destaque
    success: "#22c55e", // Verde para sucesso
    successHover: "#15803d",
    warning: "#fbbf24", // Amarelo para aviso
    warningHover: "#a16207",
    error: "#f87171", // Vermelho para erro
    errorHover: "#dc2626",
    info: "#22d3ee", // Azul ciano para informação
    infoHover: "#06b6d4",
    shadow: "rgba(0, 0, 0, 0.3)", // Sombra mais proeminente no dark
    shadowHover: "rgba(0, 0, 0, 0.5)",
  },
  [THEMES.SPRING]: {
    name: "Verde Primavera",
    icon: "🌱",
    primary: "#059669", // Verde vibrante
    primaryHover: "#047857",
    primaryActive: "#065f46",
    secondary: "#6b7280", // Cinza médio
    secondaryHover: "#4b5563",
    secondaryActive: "#374151",
    background: "#f0fdf4", // Fundo verde claro
    surface: "#ffffff",
    surfaceHover: "#dcfce7",
    text: "#064e3b", // Texto verde escuro
    textSecondary: "#374151",
    textMuted: "#6b7280",
    border: "#d1fae5",
    borderLight: "#e9faef",
    accent: "#10b981",
    success: "#22c55e",
    successHover: "#15803d",
    warning: "#f59e0b",
    warningHover: "#b45309",
    error: "#ef4444",
    errorHover: "#b91c1c",
    info: "#06b6d4",
    infoHover: "#0891b2",
    shadow: "rgba(0, 0, 0, 0.05)",
    shadowHover: "rgba(0, 0, 0, 0.1)",
  },
  [THEMES.EXECUTIVE]: {
    name: "Azul Executivo",
    icon: "💼",
    primary: "#1e40af", // Azul marinho
    primaryHover: "#173187",
    primaryActive: "#1a367c",
    secondary: "#64748b",
    secondaryHover: "#475569",
    secondaryActive: "#334155",
    background: "#f8fafc",
    surface: "#ffffff",
    surfaceHover: "#e2e8f0",
    text: "#1e293b",
    textSecondary: "#475569",
    textMuted: "#94a3b8",
    border: "#cbd5e1",
    borderLight: "#e2e8f0",
    accent: "#3b82f6",
    success: "#10b981",
    successHover: "#047857",
    warning: "#f59e0b",
    warningHover: "#b45309",
    error: "#ef4444",
    errorHover: "#b91c1c",
    info: "#0ea5e9",
    infoHover: "#0284c7",
    shadow: "rgba(0, 0, 0, 0.05)",
    shadowHover: "rgba(0, 0, 0, 0.1)",
  },
  [THEMES.ELEGANT]: {
    name: "Rosa Elegante",
    icon: "🌸",
    primary: "#be185d", // Rosa escuro
    primaryHover: "#9d174d",
    primaryActive: "#831843",
    secondary: "#6b7280",
    secondaryHover: "#4b5563",
    secondaryActive: "#374151",
    background: "#fdf2f8", // Fundo rosa claro
    surface: "#ffffff",
    surfaceHover: "#ffe4e6",
    text: "#831843", // Texto rosa escuro
    textSecondary: "#374151",
    textMuted: "#6b7280",
    border: "#f3e8ff",
    borderLight: "#fce7f3",
    accent: "#ec4899",
    success: "#10b981",
    successHover: "#047857",
    warning: "#f59e0b",
    warningHover: "#b45309",
    error: "#ef4444",
    errorHover: "#b91c1c",
    info: "#06b6d4",
    infoHover: "#0891b2",
    shadow: "rgba(0, 0, 0, 0.05)",
    shadowHover: "rgba(0, 0, 0, 0.1)",
  },
  // Novo tema "Moderno" - focado em neutralidade e minimalismo, com um toque de contraste sutil
  [THEMES.MODERN]: {
    name: "Moderno",
    icon: "✨",
    primary: "#4a5568", // Cinza chumbo como cor principal
    primaryHover: "#2d3748",
    primaryActive: "#1a202c",
    secondary: "#a0aec0", // Cinza claro
    secondaryHover: "#718096",
    secondaryActive: "#4a5568",
    background: "#f7fafc", // Fundo quase branco
    surface: "#ffffff",
    surfaceHover: "#edf2f7",
    text: "#2d3748", // Texto escuro
    textSecondary: "#4a5568",
    textMuted: "#718096",
    border: "#e2e8f0",
    borderLight: "#edf2f7",
    accent: "#4299e1", // Azul suave para destaque
    success: "#48bb78",
    successHover: "#2f855a",
    warning: "#f6e05e",
    warningHover: "#d69e2e",
    error: "#fc8181",
    errorHover: "#e53e3e",
    info: "#4fd1c5",
    infoHover: "#38b2ac",
    shadow: "rgba(0, 0, 0, 0.03)", // Sombra super leve
    shadowHover: "rgba(0, 0, 0, 0.08)",
  },
};

const ThemeContext = createContext(undefined);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme deve ser usado dentro de um ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(THEMES.LIGHT);
  const [loading, setLoading] = useState(true);
  const { churchUser, currentUser } = useAuth(); // Certifique-se de que useAuth fornece churchUser e currentUser

  // Carregar tema do usuário ou localStorage
  useEffect(() => {
    const loadTheme = async () => {
      try {
        // Sempre tenta carregar do localStorage primeiro (mais confiável)
        const localTheme = localStorage.getItem("church-theme");

        if (churchUser && currentUser) {
          // Verificar se é usuário autenticado do Firebase ou usuário CPF
          const isFirebaseUser = currentUser.metodoAuth !== "cpf";

          if (isFirebaseUser) {
            // Usuário logado no Firebase - buscar documento correto por membro_id
            try {
              let userDoc = null;
              let userRef = null;

              // Se tem membro_id no churchUser, buscar por membro_id primeiro
              if (churchUser?.membro_id) {
                const usersRef = collection(db, "users");
                const membroQuery = query(
                  usersRef,
                  where("membro_id", "==", String(churchUser.membro_id))
                );
                const membroQuerySnapshot = await getDocs(membroQuery);

                if (!membroQuerySnapshot.empty) {
                  userDoc = membroQuerySnapshot.docs[0];
                  userRef = userDoc.ref;
                  console.log(
                    "[useTheme] Documento encontrado por membro_id:",
                    userDoc.id
                  );
                }
              }

              // Se não encontrou por membro_id, tentar por UID
              if (!userDoc) {
                userRef = doc(db, "users", currentUser.uid);
                userDoc = await getDoc(userRef);

                if (!userDoc.exists()) {
                  console.log(
                    "[useTheme] Documento não existe para UID:",
                    currentUser.uid
                  );
                  userDoc = null;
                }
              }

              if (userDoc && userDoc.exists() && userDoc.data().theme) {
                const savedTheme = userDoc.data().theme;
                if (Object.values(THEMES).includes(savedTheme)) {
                  setCurrentTheme(savedTheme);
                  applyTheme(savedTheme);
                  localStorage.setItem("church-theme", savedTheme);
                  return;
                }
              }

              // Se não houver tema, usar padrão e salvar se possível
              const defaultTheme =
                localTheme && Object.values(THEMES).includes(localTheme)
                  ? localTheme
                  : THEMES.EXECUTIVE;

              setCurrentTheme(defaultTheme);
              applyTheme(defaultTheme);
              localStorage.setItem("church-theme", defaultTheme);

              // Tenta salvar no documento correto se existir
              if (userRef) {
                try {
                  await setDoc(
                    userRef,
                    { theme: defaultTheme },
                    { merge: true }
                  );
                  console.log(
                    "[useTheme] Tema salvo no documento:",
                    userRef.id
                  );
                } catch (firestoreError) {
                  console.warn(
                    "Não foi possível salvar tema no Firestore:",
                    firestoreError
                  );
                }
              }
            } catch (firestoreError) {
              console.warn(
                "Erro ao acessar Firestore para tema, usando localStorage:",
                firestoreError
              );
              // Fallback para localStorage ou tema padrão
              const fallbackTheme =
                localTheme && Object.values(THEMES).includes(localTheme)
                  ? localTheme
                  : THEMES.EXECUTIVE;

              setCurrentTheme(fallbackTheme);
              applyTheme(fallbackTheme);
              localStorage.setItem("church-theme", fallbackTheme);
            }
          } else {
            // Usuário logado por CPF - sempre usar tema EXECUTIVE como padrão
            console.log(
              "Usuário logado por CPF, definindo tema EXECUTIVE como padrão"
            );

            setCurrentTheme(THEMES.EXECUTIVE);
            applyTheme(THEMES.EXECUTIVE);
            localStorage.setItem("church-theme", THEMES.EXECUTIVE);

            // Opcionalmente salvar no Firestore para consistência
            try {
              const userDocId = churchUser?.id || currentUser?.uid;
              if (userDocId) {
                const userRef = doc(db, "users", userDocId);
                await setDoc(
                  userRef,
                  { theme: THEMES.EXECUTIVE },
                  { merge: true }
                );
                console.log(
                  "[useTheme] Tema EXECUTIVE salvo para usuário CPF no documento:",
                  userDocId
                );
              }
            } catch (firestoreError) {
              console.warn(
                "Erro ao salvar tema EXECUTIVE para usuário CPF no Firestore:",
                firestoreError
              );
            }
          }
        } else {
          // Usuário não logado - usar localStorage ou tema padrão
          if (localTheme && Object.values(THEMES).includes(localTheme)) {
            setCurrentTheme(localTheme);
            applyTheme(localTheme);
          } else {
            // Se não houver tema salvo no localStorage, defina Azul Executivo como padrão
            setCurrentTheme(THEMES.EXECUTIVE);
            applyTheme(THEMES.EXECUTIVE);
            localStorage.setItem("church-theme", THEMES.EXECUTIVE);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar tema:", error);
        // Em caso de erro, garante que o tema padrão Azul Executivo seja aplicado
        setCurrentTheme(THEMES.EXECUTIVE);
        applyTheme(THEMES.EXECUTIVE);
        localStorage.setItem("church-theme", THEMES.EXECUTIVE);
      } finally {
        setLoading(false);
      }
    };

    loadTheme();
  }, [churchUser, currentUser]); // Dependências para recarregar o tema quando o usuário muda

  // Aplicar tema ao DOM
  const applyTheme = (theme) => {
    const config = THEME_CONFIGS[theme];
    const root = document.documentElement;

    // Aplicar variáveis CSS
    Object.entries(config).forEach(([key, value]) => {
      if (key !== "name" && key !== "icon") {
        root.style.setProperty(`--color-${key}`, value);
      }
    });

    // Remover classes de tema antigas e adicionar a nova
    root.className = root.className
      .split(" ")
      .filter((cls) => !cls.startsWith("theme-"))
      .join(" ");
    root.classList.add(`theme-${theme}`);

    // Atualizar meta tag theme-color para PWA
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute("content", config.background);
    }
  };

  // Alterar tema
  const changeTheme = async (newTheme) => {
    if (!Object.values(THEMES).includes(newTheme)) {
      console.error("Tema inválido:", newTheme);
      return;
    }

    // Verificar se é usuário CPF - se for, não permitir mudança de tema
    if (currentUser?.metodoAuth === "cpf") {
      console.log(
        "Usuário CPF: mudança de tema desabilitada, mantendo EXECUTIVE"
      );
      return;
    }

    try {
      setCurrentTheme(newTheme);
      applyTheme(newTheme);

      // Sempre salva no localStorage como backup
      localStorage.setItem("church-theme", newTheme);

      if (churchUser && currentUser) {
        // Verificar se é usuário autenticado do Firebase ou usuário CPF
        const isFirebaseUser = currentUser.metodoAuth !== "cpf";

        if (isFirebaseUser) {
          // Buscar documento correto por membro_id primeiro
          try {
            let userRef = null;

            // Se tem membro_id, buscar por membro_id primeiro
            if (churchUser?.membro_id) {
              const usersRef = collection(db, "users");
              const membroQuery = query(
                usersRef,
                where("membro_id", "==", String(churchUser.membro_id))
              );
              const membroQuerySnapshot = await getDocs(membroQuery);

              if (!membroQuerySnapshot.empty) {
                userRef = membroQuerySnapshot.docs[0].ref;
                console.log(
                  "[useTheme] Salvando tema no documento encontrado por membro_id:",
                  membroQuerySnapshot.docs[0].id
                );
              }
            }

            // Se não encontrou por membro_id, usar UID
            if (!userRef) {
              userRef = doc(db, "users", currentUser.uid);
              console.log(
                "[useTheme] Salvando tema usando UID:",
                currentUser.uid
              );
            }

            await setDoc(userRef, { theme: newTheme }, { merge: true });
          } catch (firestoreError) {
            console.warn(
              "Não foi possível salvar tema no Firestore:",
              firestoreError
            );
            // Mesmo com erro no Firestore, o tema já foi aplicado e salvo no localStorage
          }
        } else {
          // Usuário CPF - tentar salvar no Firestore usando ID do documento
          console.log("Usuário CPF: tentando salvar tema no banco de dados");

          try {
            const userDocId = churchUser?.id || currentUser?.uid;
            if (userDocId) {
              const userRef = doc(db, "users", userDocId);
              await setDoc(userRef, { theme: newTheme }, { merge: true });
              console.log(
                "[useTheme] Tema salvo para usuário CPF no documento:",
                userDocId
              );
            } else {
              console.log(
                "Usuário CPF: sem ID válido, tema salvo apenas no localStorage"
              );
            }
          } catch (firestoreError) {
            console.warn(
              "Erro ao salvar tema para usuário CPF no Firestore:",
              firestoreError
            );
            // Tema já foi aplicado e salvo no localStorage como fallback
          }
        }
      }
    } catch (error) {
      console.error("Erro ao salvar tema:", error);
      // Mesmo com erro, mantém o tema aplicado localmente
    }
  };

  // Obter configuração do tema atual
  const getThemeConfig = (theme = currentTheme) => {
    return THEME_CONFIGS[theme] || THEME_CONFIGS[THEMES.LIGHT];
  };

  // Verificar se é tema escuro (útil para ícones ou componentes que precisam de lógica específica)
  const isDarkTheme = (theme = currentTheme) => {
    return theme === THEMES.DARK;
  };

  // Obter cor adaptativa (para ícones monocromáticos ou textos específicos)
  const getAdaptiveColor = (type = "text") => {
    const config = getThemeConfig();
    return config[type] || config.text; // Retorna a cor específica ou a cor de texto padrão
  };

  const value = {
    currentTheme,
    themes: THEMES,
    themeLabels: THEME_LABELS,
    themeConfigs: THEME_CONFIGS,
    changeTheme,
    getThemeConfig,
    isDarkTheme,
    getAdaptiveColor,
    loading,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
